import React, { useState,useEffect } from "react";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { Button, Modal, Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import paypal from "../../Assets/Images/PayPal 1.png";
import stripe from "../../Assets/Images/Group (1).png";
import "../../pages/summary.css";
import { useDispatch, useSelector } from "react-redux";


const toastId = "payment-toast";
const toastId2 = "flight-toast";
const toastId3 = "update-toast";
const toastId4 = "returnFlightNo";
const toastId5 = "returnDate";
const stripePromise = loadStripe("pk_test_51Qx8hyLPPTvQPccQvZEBSEuLWAiW4m9AlvQh3tbvbJbRC9Ff5RiNvd1iUJOm5UZLoOg4JNO13BsvL7JUSa2zD5Sy000kfT1HIt");


const CheckoutForm = ({ setPayType, handleClose, paymentCompleted, setPaymentCompleted, bookingId, handleClick,dataCheck }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const paymentData = {
    _id: bookingId,
    paymentType: "online",
    failStatus: "Failed"
  };

  // const setPaymentTypeOnline = async () => {
  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_URL}api/booking/updateRideStatusAndPaymentType`,
  //       paymentData
  //     );
  //   } catch (error) {
  //     console.error("Failed to update payment type:", error);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      toast.error("Stripe.js has not loaded yet.");
      return;
    }
  
    setLoading(true);
  
    try {
  
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements, 
        confirmParams: {
          return_url: window.location.origin + "/company/BussinessBooking",
        },
      });
      localStorage.setItem("paymentIntent", JSON.stringify(paymentIntent));
      if (error) {
        toast.error(`Payment failed: ${error.message}`);
      } else if (paymentIntent) {

  
        if (paymentIntent.status === "requires_action") {
          toast.info("Payment requires additional action.");
        } else if (paymentIntent.status === "succeeded") {
          toast.success("Payment successful");
          handleClick()
          setPaymentCompleted(true);
        } else {
          toast.error(`Payment status: ${paymentIntent.status}`);
        }
      }
    } catch (err) {
      toast.error("Payment failed due to an unexpected error.");
      console.error("Payment error:", err);
    }
  
    setLoading(false);
  };
  
  

  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h6" textAlign="center" sx={{ mb: 4 }}>
        Enter Payment Details
      </Typography>
      <PaymentElement />
      <Button
        type="submit"
        disabled={!stripe || loading}
        variant="contained"
        color="primary"
        //onClick={setPaymentTypeOnline}
        fullWidth
        sx={{ mt: 4 }}
      >
        {loading ? "Processing..." : "Pay Now"}
      </Button>
    </form>
  );
};

const BussinessAgentStripePayment = ({ amount,bookingDetails, showEditModal , fromLocation, toLocation, flightNumber , setPayType, paymentCompleted, setPaymentCompleted,handleClick,dataCheck }) => {

const reduxdata = useSelector((state) => state);
let id = reduxdata.homeReducer?.bookingId;
  const [open, setOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);

  const handleOpen = async () => {
    if (paymentCompleted) {
      if (!toast.isActive(toastId)) {
        toast.info("Payment already done. You cannot change it now.", {
          toastId,
          autoClose: 2500,
        });
      }
      return;
    }

    if ((fromLocation.includes("Airport") || fromLocation.includes("Flughafen") || fromLocation.includes("Terminal")) && !flightNumber) {
      if (!toast.isActive(toastId2)) {
        toast.info("Please Enter Flight Number using Edit Button", {
          toastId2,
          autoClose: 2500,
        });
      }
      return;
    }
    if ((bookingDetails?.toLocation.includes("Airport") || bookingDetails?.toLocation.includes("Flughafen") || bookingDetails?.toLocation.includes("Terminal")) && !bookingDetails?.returnFlightNumber && bookingDetails?.bookingType=="Return" ) {
      if (!toast.isActive(toastId4)) {
        toast.info("Please Enter return Flight Number using Edit Button", {
          toastId4,
          autoClose: 2500,
        });
      }
      return;
    }
    if(bookingDetails?.bookingType=="Return" && !bookingDetails?.returnDate){
      if (!toast.isActive(toastId5)) {
        toast.info("Please enter return date using Edit Button", {
          toastId5,
          autoClose: 2500,
        });
      }
      return;
    }


    if (showEditModal) {
      if (!toast.isActive(toastId3)) {
        toast.info("Click on Update Button to Continue.", {
          toastId3,
          autoClose: 2500,
        });
      }
      return;
    }

    if (!amount || isNaN(amount) || amount <= 0) {
      console.error("Invalid amount detected:", amount);
      toast.error("Invalid payment amount");
      return;
    }

    setOpen(true);
    setPayType("Stripe");

    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}api/booking/create-payment-intent`, {
        amount: Math.round(amount * 100), // Convert to cents
        currency: "eur",
      });
      setClientSecret(response.data.clientSecret);
    } catch (error) {
      console.error("Error creating payment intent:", error);
      toast.error("Error creating payment intent");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setPayType('');
    setPaymentCompleted(false);
  };

  return (
    <div>
      <Button
  className="px-xl-5 px-lg-2 px-md-1 responsiveButtons"
  variant="outlined" // Keep outlined since we override the background color manually
  color="primary"
onClick={async () => {
  const isValid = await dataCheck();
  if (isValid) {
    handleOpen();
  }
}}  sx={{
    width: "170px",
    height: "38px",
    paddingRight: "2px",
    paddingLeft: "8px",
    backgroundColor: paymentCompleted ? "#FFB343" : "transparent", // Change color on payment completion
    color: paymentCompleted ? "#000" : "inherit", // Ensure text contrast
    borderColor: paymentCompleted ? "#FFB343" : "rgba(0, 0, 0, 0.23)", // Change border color
    "&:hover": {
      backgroundColor: paymentCompleted ? "#FFA500" : "#f0f0f0", // Slightly darker yellow on hover
    },
  }}
>
  <img src={stripe} width="60px" className="ms-2 me-2" />
  <span style={{ fontSize: "24px", marginRight: "8px" }}>/</span>
  <img src={paypal} width="72px" className="me-2" />
</Button>


      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "480px",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
          }}
        >
          {clientSecret ? (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutForm
                setPayType={setPayType}
                handleClose={handleClose}
                paymentCompleted={paymentCompleted}
                setPaymentCompleted={setPaymentCompleted}
                bookingId={id}
                handleClick={handleClick}
              />
            </Elements>
          ) : (
            <Typography textAlign="center">
              Loading Payment Options...
            </Typography>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default BussinessAgentStripePayment;
